var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpoilerAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1234_40835)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.8049 10.2871C43.6082 20.058 37.4651 30.8848 31.2404 38.2575C30.7941 28.8832 31.9197 19.4346 34.5582 10.4288C37.1319 1.63618 46.0588 0.0720815 44.809 10.2831",
    stroke: "#4CC4B0",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.504 47.0223C33.7048 49.733 32.7025 54.3797 29.5911 55.9656C26.4798 57.5514 22.1501 55.6568 21.1761 52.3066C20.2021 48.9564 22.8209 45.0498 26.2934 44.6489C29.7617 44.2519 33.1878 47.4279 33.0743 50.9185",
    stroke: "#4CC4B0",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1234_40835"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.5921,
    height: 57.1868,
    fill: "white",
    transform: "matrix(-0.693011 -0.720927 -0.720927 0.693011 64.5073 24.2188)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpoilerAlert);
export default __webpack_public_path__ + "static/media/spoiler-alert.5a8f9efaef9037a3692ff60ab254f7f8.svg";
export { ForwardRef as ReactComponent };